export const isDev = () => {
  return window.location.href.search(/(vercel.app|:3000)/g) !== -1
}